import React from 'react';
import './Chapters.scss';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import wrapPhoto1 from '../../Assets/wrapPhoto1.jpg';

function Chapter3() {
  const photoData = {
    imgSrc: wrapPhoto1,
    caption: 'Michael Simonetta | Perfection Fresh CEO',
    float: 'right' //pass in "right" or "left"
  };

  return (
    <>
      <section className="chapter">
        <p className="chapter__title">On the Ground</p>
        <p className="chapter__paragraph">
          Perfection has come a long way since its humble beginnings in the late 1960s. Founder Tony
          Simonetta started the company as a small, family-run garden and market in western Sydney.
          But he saw an opportunity to grow the business into a wholesale operation in the 1970s,
          supplying retailers and customers from a network of growers all across Australia. The
          company now comprises eight massive farming operations across Australia and supplies
          retailers, restaurants, and even airlines across the whole continent. Through a complex
          blend of trucking, rail, and air transport, Perfection can deliver even the most delicate
          perishables to consumers at peak freshness.{' '}
        </p>
        <div>
          <TextWrapPhoto photoData={photoData} />
          <p className="chapter__paragraph">
            An empire, however, is not built on just planting seeds. For a particular fruit or
            vegetable to make the cut, it must satisfy several key criteria: top-notch flavor and
            experience for the consumer, yield and crop friendliness for the grower, and resistance
            to physical threats like climate events, pests, and disease. And even then, a trial run
            to bring a new product to the market would entail a commitment of two to five years for
            crop growth and evaluation, so projecting the unique value and mass appeal of a
            particular product takes great care.
          </p>
        </div>
        <p className="chapter__paragraph">
          As the Simonetta family forged ahead, they knew the margins for error in agriculture at
          scale were increasingly narrow and saw that technology would spell the difference between
          failure and continued success. So Perfection adopted a tech-focused strategy to
          future-proof the business. This started with enterprise resource planning in 2005, major
          investments in controlled-environment agriculture in 2007, and a whole-hog integration of
          analytics and software development in 2014.
        </p>
      </section>
      <section className="chapter">
        <p className="chapter__title">On the Grid</p>
        <p className="chapter__paragraph">
          Lenovo ThinkAgile VX servers, powered with 3<sup>rd</sup> Gen Intel<sup>®</sup> Xeon
          <sup>®</sup> Scalable processors that have been optimized for faster analytics, are hard
          at work parsing data from a variety of sources back in Perfection’s head office in Sydney.
          Temperature, wind speed/direction, humidity, and rainfall information are pulled in
          through local weather stations. At the farms, IoT sensors stream data from CO2 monitors,
          moisture sensors, and light meters to track crop yields and growth conditions. Solar IP
          cameras, location/movement trackers for farm vehicles and storage containers, and
          labor-tracking software in mobile devices deliver key insights on farm productivity.
        </p>
      </section>
    </>
  );
}

export default Chapter3;
